/* eslint-disable */
import changeCase from 'change-object-case';
import moment from 'moment';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert, Glyphicon } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch, money } from '../../utils/util';
import { Elements, StripeProvider, CardElement, injectStripe } from 'react-stripe-elements';
import Highlighter from "react-highlight-words";
import FontAwesome from 'react-fontawesome';
import { DateRangePicker, SingleDatePicker, DayPickerRangeController } from 'react-dates';

import OzFormComponent from './OzFormComponent';
import Loading from './Loading';
import './BookingWidget.css';

import {
  getLocation,
  listBookableSlots,
} from '../../actions';


const deltaDays = 3;

class BookingWidget extends Component {

  state = {};

  constructor(props) {
    super(props);
    this.state.date = moment();
  }

  componentDidMount() {
    this.setState({ loading: 2 });

    this.refresh(this.state.date)
      .then(() => {
        let loading = this.state.loading - 1;
        this.setState({ loading });
      });

    this.props.getLocation(this.props.locationId, { local: true, silent: true })
      .then(resp => {
        let loading = this.state.loading - 1;
        console.log('booking widget got location:', resp);
        this.setState({ loading, location: resp.obj, })
      });
  }

  refresh(date, setLoading) {
    let params = {
      schedule__room__location_id: this.props.locationId,
      days: deltaDays,
      date: date.format('YYYY-MM-DD'),
    }

    if (setLoading) {
      this.setState({ loadingBookableSlots: true });
    }
    return this.props.listBookableSlots(params, { local: true, silent: true })
      .then(resp => {
        this.setState({
          bookableSlots: resp,
          date: date,
          loadingBookableSlots: false,
        });
      });
  }

  prev() {
    let date = moment(this.state.date).subtract(deltaDays, 'days');
    this.setState({ loadingPrev: true });
    this.refresh(date)
      .then(() => {
        this.setState({ loadingPrev: false });
      });
  }

  next() {
    let date = moment(this.state.date).add(deltaDays, 'days');
    this.setState({ loadingNext: true });
    this.refresh(date)
      .then(() => {
        this.setState({ loadingNext: false });
      });
  }

  hasPrev() {
    return this.state.date.isAfter(moment());
  }

  renderPicker() {
    return (
      <div className="date-picker">
        <div>
          <Button disabled={!this.hasPrev()} className="change-date" onClick={() => this.prev()}>
            {!this.state.loadingPrev && <span><FontAwesome name="chevron-circle-left" /> Prev</span>}
            {this.state.loadingPrev && <Loading size="small" />}
          </Button>
        </div>
        <div className="calendar">
          <SingleDatePicker
            date={this.state.date}
            onDateChange={date => this.refresh(date, true)}
            focused={this.state.focused}
            onFocusChange={({ focused }) => this.setState({ focused })}
            id="when"
            numberOfMonths={1}
            displayFormat="ddd, M/D"
            isDayBlocked={(date) => date.isBefore(moment())}
          />
        </div>
        <div>
          <Button className="change-date" onClick={() => this.next()}>
            {!this.state.loadingNext && <span>Next <FontAwesome name="chevron-circle-right" /></span>}
            {this.state.loadingNext && <Loading size="small" />}
          </Button>
        </div>
      </div>
    );
  }

  renderSchedule() {
    let location = this.state.location;
    let bookableSlots = this.state.bookableSlots;
    if (!location || !bookableSlots) {
      return;
    }

    let slotsByDate = {};
    for (let bs of bookableSlots.items) {
      let date = bs.dateStr;
      if (!slotsByDate[date]) {
        slotsByDate[date] = [];
      }
      slotsByDate[date].push(bs);
    }

    let dates = [];
    for (let i = 0; i < deltaDays; i++) {
      dates.push(moment(this.state.date).add(i, 'days').format('YYYY-MM-DD'));
    }

    let dateNodes = [];
    for (let date of dates) {
      let dateSlots = slotsByDate[date] || [];
      dateSlots.sort((a, b) => a.datetime.localeCompare(b.datetime));

      let nodes = dateSlots.map(bs => {
        let privacyPretty = {
          always: 'Private',
          fee: 'Private option available',
          no: '',
        }[bs.room.privacy];
        return (
          <div className="bookable-slot" key={bs.id}>
            <div className="start-time">{bs.prettyStart}</div>
            <div className="room-info">
              <div className="room-name">{bs.room.name}</div>
              <div className="room-minutes">{bs.room.minutes} minutes</div>
            </div>
            <div className="room-capacity">
              <div><b>{bs.room.minPeople}-{bs.room.maxPeople} players</b></div>
              <div>{privacyPretty}</div>
            </div>
            {/*<div className="privacy"></div>*/}
            <div className="slots-left"><b>{bs.slotsLeft} of {bs.totalSlots}</b><br/>slots left</div>
            <div className="controls">
              <Button bsStyle="primary">Book Now</Button>
            </div>
          </div>
        );
      });
      let dateNode = (
        <div key={date} className="date">
          <div className="date-title">{moment(date, 'YYYY-MM-DD').format('dddd, MMM Do')}</div>
          <div className="date-slots">{nodes}</div>
        </div>
      );
      dateNodes.push(dateNode);
    }

    return (
      <div className="location">
        {this.renderPicker()}
        {!this.state.loadingBookableSlots && <div className="dates">{dateNodes}</div>}
        {this.state.loadingBookableSlots && <Loading />}
      </div>
    );
  }

  render() {
    return (
      <div className="BookingWidget">
        {!!this.state.loading && <Loading />}
        {!this.state.loading && this.renderSchedule()}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    getLocation,
    listBookableSlots,
  });
}

export default connect(mapStateToProps, mapDispatchToProps)(BookingWidget);



/** WEBPACK FOOTER **
 ** ./src/components/partials/BookingWidget.js
 **/